import { ProcessedMessage } from './useProcessMessage'
import { toast } from 'react-toastify'
import { toastContainerId } from '../../pages/App'

/**
 * Message in order to revoke a TimeSuggestionDialog.
 */
export type CancelTimeTrackingNotification = ProcessedMessage<{
    timeSuggestionId: string
}>

/**
 * Process a cancel time tracking event message. This revokes the TimeSuggestionDialog.
 */
export default function useProcessCancelTimeTrackingNotification() {
    return (message: CancelTimeTrackingNotification) => toast.dismiss({ id: message.data.timeSuggestionId, containerId: toastContainerId })
}
